import { LeadTranslate } from './leadTranslate.model';

const leadTranslateEN: LeadTranslate = {
  header: {
    label: {
      search: 'Search by name or email',
    },
  },
  list: {
    title: 'Leads',
    searchPlaceholder: 'Search by name, email, phone or Instagram',
    dotsOptions: {
      activate: 'Activate',
      deactivate: 'Deactivate',
      detail: 'Details',
    },
    emptyState: "We didn't find any leads",
    emptyStateDetail: 'Try another name or email!',
    tooltip: {
      instagram: 'Open Instagram',
    },
    filters: {
      source: 'Source',
      sourceAll: 'All sources',
      clear: 'Clear filters',
    },
  },
  details: {
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    buttons: {
      addEvent: 'New event',
      addTodo: 'New task',
      edit: 'Edit',
      activate: 'Activate',
      deactivate: 'Deactivate',
      message: 'Message',
      back: 'Back to lead list',
    },
    notFound: {
      title: 'Lead not found',
      description:
        'It may have been removed or the address you accessed is incorrect.',
      backToList: 'Back to list',
    },
    label: {
      email: 'Email',
      instagram: 'Instagram',
      phone: 'Phone number',
      createdAt: 'Created at',
      notes: 'Notes',
      events: 'Events',
      source: 'Source',
      referrer: 'Referred by',
      lostReason: 'Loss reason',
      lostReasonNote: 'Loss notes',
    },
    contact: {
      email: 'Send email',
      whatsapp: 'Open WhatsApp',
      call: 'Call',
    },
    tooltip: {
      instagram: 'Open Instagram',
    },
    tabs: {
      sectionLabel: 'Section',
      general: 'General',
      events: 'Events',
      sales: 'Sales',
      eventsEmpty: 'No events registered',
    },
  },
  modal: {
    deactivate: {
      title: 'Deactivate',
      text: 'Are you sure you want to deactivate this lead?',
      secondaryText: 'All associated events will be cancelled',
      confirmButtonText: 'Yes, deactivate',
      cancelButtonText: 'Cancel',
    },
  },
  widget: {
    title: 'Recent leads',
    viewAll: 'View all',
    empty: 'No leads yet',
    createdAt: 'created {{distance}}',
    addNew: 'New lead',
  },
  source: {
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    TIKTOK: 'TikTok',
    GOOGLE: 'Google',
    SITE: 'Website',
    INDICACAO: 'Referral',
    OUTRO: 'Other',
  },
  reviewStatus: {
    title: 'Google review',
    description: 'Track the review request for this client.',
    field: 'Review status',
    updateError: 'Could not update the review status',
    option: {
      NOT_REQUESTED: 'Not requested',
      REQUESTED: 'Requested',
      RECEIVED: 'Received',
    },
    chip: {
      REQUESTED: 'Review requested',
      RECEIVED: 'Review received',
    },
  },
  lostReason: {
    PRECO: 'Price',
    AGENDA: 'Availability',
    CONCORRENTE: 'Competitor',
    SEM_RETORNO: 'No response',
    DESISTIU: 'Gave up',
    OUTRO: 'Other',
  },
  deactivate: {
    title: 'Deactivate lead',
    description:
      'Optionally record why this lead was lost. All associated events will be cancelled.',
    reasonPlaceholder: 'Loss reason',
    reasonNone: 'No reason',
    notePlaceholder: 'Notes (optional)',
    cancel: 'Cancel',
    confirm: 'Deactivate',
    errors: {
      noteMaxLength: 'Notes must be at most {{max}} characters',
      generic: 'Could not deactivate the lead',
    },
  },
  messageComposer: {
    title: 'Send message',
    selectPlaceholder: 'Choose a template',
    preview: 'Preview',
    copy: 'Copy',
    copied: 'Message copied',
    copyError: 'Could not copy the message',
    openWhatsApp: 'Open in WhatsApp',
    noPhone: 'This lead has no phone number registered.',
    empty: 'No message templates yet',
    emptyHint: 'Create templates in Settings to reuse them here.',
    close: 'Close',
  },
};

export default leadTranslateEN;
